<template>
  <v-layout row wrap>
    <v-flex xs2>
      <v-checkbox label="MOTO Enabled" v-model="motoEnabled" ></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="Tip Enabled" v-model="tipEnabled"></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="Cashback" v-model="cashBackEnabled"></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="Prompt Reference" v-model="promptReferenceEnabled"></v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderDetailCardBrands',
  computed: {
    motoEnabled: {
      get () { return this.$store.state.order.motoEnabled },
      set (value) { this.$store.commit('updateOrder', ['motoEnabled', value]) }
    },
    tipEnabled: {
      get () { return this.$store.state.order.tipEnabled },
      set (value) { this.$store.commit('updateOrder', ['tipEnabled', value]) }
    },
    cashBackEnabled: {
      get () { return this.$store.state.order.cashBackEnabled },
      set (value) { this.$store.commit('updateOrder', ['cashBackEnabled', value]) }
    },
    promptReferenceEnabled: {
      get () { return this.$store.state.order.promptReferenceEnabled },
      set (value) { this.$store.commit('updateOrder', ['promptReferenceEnabled', value]) }
    }
  }
}
</script>

<style scoped>

</style>
